import { render, staticRenderFns } from "./SearchChat.vue?vue&type=template&id=7c5191e5&scoped=true&"
import script from "./SearchChat.vue?vue&type=script&lang=js&"
export * from "./SearchChat.vue?vue&type=script&lang=js&"
import style0 from "./SearchChat.vue?vue&type=style&index=0&id=7c5191e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5191e5",
  null
  
)

export default component.exports